import { ApiError } from './apiError';

export const ALLOWED_RANGES = ['today', '7d', '30d'];

// Required numeric fields per metric - mirrors docs/API_CONTRACT.md
const REQUIRED = {
  visitors: ['value', 'previous'],
  conversations: ['value', 'previous'],
  leads: ['value', 'previous'],
  conversionRate: ['value', 'previous'],
  aiResponse: ['value', 'previous', 'messages'],
  escalationRate: ['value', 'previous', 'escalated', 'total'],
  responseTime: ['value', 'previous', 'p90'],
  aiUsage: ['tokensUsed', 'tokensQuota', 'cost', 'budget'],
};

export function validateRange(range) {
  if (!ALLOWED_RANGES.includes(range)) {
    throw new ApiError(400, 'INVALID_RANGE', `Unsupported range "${range}"`);
  }
}

export function validatePayload(key, data) {
  if (data == null) return; // empty state is valid
  const bad = (msg) => {
    throw new ApiError(502, 'INVALID_PAYLOAD', `${key}: ${msg}`);
  };
  if (key === 'engagementTrend') {
    if (!Array.isArray(data.labels) || !Array.isArray(data.series)) bad('labels/series missing');
    data.series.forEach((s) => {
      if (!Array.isArray(s.values) || s.values.length !== data.labels.length) bad('series length mismatch');
    });
    return;
  }
  if (key === 'ctaPerformance') {
    if (!Array.isArray(data.labels) || !Array.isArray(data.series)) bad('labels/series missing');
    data.series.forEach((s) => {
      if (!Array.isArray(s.values) || s.values.length !== data.labels.length) bad('series length mismatch');
    });
    return;
  }
  if (key === 'supportResolution') {
    ['resolved', 'inProgress', 'handover'].forEach((f) => {
      if (!Number.isFinite(data[f])) bad(`${f} must be a number`);
    });
    return;
  }
  (REQUIRED[key] || []).forEach((f) => {
    if (!Number.isFinite(data[f])) bad(`${f} must be a number`);
  });
  if (data.sparkline && !data.sparkline.every(Number.isFinite)) bad('sparkline must be numbers');
}
